import { RewindTypes } from '|>/shared/constants/rewind'
import { Events } from '|>/shared/events'
import { on, register } from '|>/shared/vjs'
import { BaseComponent } from '../../base'

/**
 * Manage pause in live content
 */
@register
export class LivePauseControl extends BaseComponent {
  @on(Events.Media.IsRewound)
  private isRewound: Events.Media.IsRewound = false

  @on(Events.Media.RewindDetails)
  private rewindDetails: Events.Media.RewindDetails

  private isAllowed: boolean = false

  pauseTimeStamp: number = 0

  constructor(player) {
    super(player)
  }

  @on('playing')
  onPlaying() {
    // allow pause control only if video actually started once
    this.isAllowed = true
  }

  @on(Events.Media.ContentChanged)
  onContentChanged() {
    this.isAllowed = false
  }

  @on('play')
  handleLivePlay() {
    const liveSeekBar = this.parentComponent_

    if (liveSeekBar && this.isRewound && this.pauseTimeStamp) {
      // if rewind by live pause case - freeze current percent for a while
      liveSeekBar.tempPercent = this.pauseTimeStamp

      this.pauseTimeStamp = 0
      liveSeekBar.clearWithDelayTempPercent()
    }
  }

  /**
   * Handle pause in live mode with rewind capability
   * Sets rewind state to show growing time lag, goes rewind on next playback
   */
  @on('pause')
  handleLivePause() {
    const liveSeekBar = this.parentComponent_
    const liveProgressControll = liveSeekBar.parentComponent_

    if (!liveSeekBar || !liveProgressControll) return

    if (!liveProgressControll.isInteractive || !this.isAllowed) return

    let pauseTimeStamp = liveSeekBar.getPlaybackStamp({ paused: false })

    // timeshift is bit tricky
    if (this.rewindDetails?.rewindType === RewindTypes.timeshift)
      pauseTimeStamp = pauseTimeStamp - 5 * 1000

    this.pauseTimeStamp = pauseTimeStamp
    this.player_.trigger(Events.Player.DelayedLiveRewind, pauseTimeStamp / 1000)
  }
}

LivePauseControl.options = {
  createEl: false,
}
